import { allowAllFeatureGate } from "./defaultGate";
import type { FeatureGate } from "./types";

export const getFeatureGate = (): FeatureGate => allowAllFeatureGate;
